import script from "./InfoBox.vue?vue&type=script&setup=true&lang=ts"
export * from "./InfoBox.vue?vue&type=script&setup=true&lang=ts"

import "./InfoBox.vue?vue&type=style&index=0&id=714dbd82&lang=scss"

const __exports__ = script;

export default __exports__